<script>
    import { Typography, CheckBox } from '$lib/components/UI'
    export const data = {}
    export let value = false
    export let fetching = false
</script>

<Typography type="body" color="grey-800">
    El Proveedor declara conocer y aceptar que los datos de carácter personal
    que fueron proporcionados en ocasión al registro "Portal de Proveedores" de
    La Caja, serán tratados de acuerdo a la ley 25.326 y tendrán el carácter de
    declaración jurada. Los datos serán incorporados y tratados en una base de
    datos, la cual se encuentra registrada en la Agencia de Acceso a la
    Información Pública, cuyo destinatario y titular es La Caja.
    <br /><br />
    El Proveedor tiene el derecho de acceso a los mismos en forma gratuita, de acuerdo
    a lo que establece en el artículo 14, inciso 3 de la Ley 25.326.
    <br /><br />
    La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la Ley Nº
    25.326, está facultado para atender las denuncias y reclamos que se inicien con
    relación al incumplimiento de las normas sobre protección de datos personales.
    <!-- Presto conformidad para que todo intercambio de comunicacion y/o documentación con Caja de Seguros S.A. relacionada con servicio sea efectuada vía e-mail comunicación y/o a través de cualquier otro medio electrónico (chat online, WhatsApp). Asimismo, presto mi consentimiento explícito para que La Caja me envíe mensajes por WhatsApp al teléfono celular informando. -->
</Typography>
<CheckBox
    disabled={fetching}
    label="Acepto los términos y condiciones"
    bind:value
/>
